export const encodeUrl = (uniqueName: string): string => uniqueName && encodeURIComponent(uniqueName.replace(/%/g, '#&&#'));
